import { createStore } from 'vuex'
import VuexPersist from 'vuex-persist'
import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const vuexPersist = new VuexPersist({
    key: 'my-app',
    storage: window.localStorage
})

const store = createStore({
    state() {
        const initial = { ...state }
        try {
            const persisted = localStorage.getItem('isSSO')
            if (persisted === '1') initial.isSSO = true
            if (persisted === '0') initial.isSSO = false
        } catch (e) { /* noop */ }
        return initial
    },
    mutations: mutations,
    actions: actions,
    getters: getters,
    plugins: [vuexPersist.plugin]
}
)

export default store
